export const selectDefaultStyle = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    border: "none",
    padding: 0,
    minHeight: "auto",
    height: "29px",
  }),
  indicatorSeparator: (provided, state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    // icon: ``,
  }),
  valueContainer: (provided, state) => ({
    // ...provided,
    padding: "0",
    display: "block",
  }),
  placeholder: (provided, state) => ({
    // ...provided,
    padding: "0",
    display: "block",
    padding: "6.5px 13px",
    fontSize: "0.875rem",
  }),
  singleValue: (provided, state) => ({
    // ...provided,
    padding: "6.5px 13px",
    fontSize: "0.875rem",
  }),
  input: (provided, state) => ({
    ...provided,
    lineHeight: "0",
    display: "block",
    padding: "6.5px 13px",
    fontSize: "0.875rem",
    top: 0,
    position: "absolute",
  }),
  option: (provided, state) => ({
    ...provided,
    lineHeight: "1.25rem",
    fontSize: "0.875rem",
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: 999999,
    // lineHeight: "14px",
  }),
};
